import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { PageContainer } from '@ant-design/pro-layout';
import { useQuery } from '@apollo/client';
import { Descriptions, Card, Breadcrumb } from 'antd';
import { GET_ANNUAL_REPORTS } from 'gql/annualReports';
import { DateDisplay, Main, FileList } from 'components/layout';

const AnnualReport = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_ANNUAL_REPORTS, {
    variables: {
      ids: [id],
    },
  });

  const annualReport = data?.annualReports[0];
  return (
    <Main style={{ padding: 0 }}>
      <PageContainer
        ghost
        header={{
          title: 'Annual Report Detail',
          breadcrumb: (
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to="/annual-reports#reports">F/SLTC Annual Report</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Annual Report Detail</Breadcrumb.Item>
            </Breadcrumb>
          ),
        }}
        loading={loading}
      >
        <Card>
          <Descriptions column={{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 1, xs: 1 }}>
            <Descriptions.Item label="Reporting Period" span={3}>
              <DateDisplay date={annualReport?.reportingPeriod.startDate} /> -{' '}
              <DateDisplay date={annualReport?.reportingPeriod.endDate} />
            </Descriptions.Item>
            <Descriptions.Item label="Scheduled Submission Date" span={3}>
              <DateDisplay
                date={annualReport?.reportingPeriod.scheduledDeadline}
              />
            </Descriptions.Item>
            <Descriptions.Item label="Actual Submission Date" span={3}>
              <DateDisplay date={annualReport?.actualSubmissionDate} />
            </Descriptions.Item>
            <Descriptions.Item label="Faculty / School" span={3}>
              {annualReport?.faculty.abbreviation} -{' '}
              {annualReport?.faculty.name}
            </Descriptions.Item>
            <Descriptions.Item label="Project Category" span={3}>
              {annualReport?.projectCategory.name}
            </Descriptions.Item>
            <Descriptions.Item label="Annual Report" span={3}>
              <FileList files={[annualReport?.attachment]} />
            </Descriptions.Item>
            <Descriptions.Item label="Remarks" span={3}>
              {annualReport?.remarks}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </PageContainer>
    </Main>
  );
};

export default AnnualReport;
